import { AnalyticsPageReducer, analyticsFeatureApi } from './redux';

export const AnalyticsFeatureMiddlewares = [
  analyticsFeatureApi.middleware,
];

export const AnalyticsFeatureReducers = {
  AnalyticsPageReducer,
  [analyticsFeatureApi.reducerPath]: analyticsFeatureApi.reducer,
};
